export const THEME_COLOR = "#000000";
export const GRAY_COLOR = "#899CBB";
